import React, { useState } from "react";
import { CiHeart } from "react-icons/ci";
import { GoDotFill } from "react-icons/go";
import { Link } from "react-router-dom";
import { IoArrowForwardSharp, IoHeart, IoAdd } from "react-icons/io5";
import { ImSpinner8 } from "react-icons/im";
import { useTranslation } from "react-i18next";
export default function SubjectCard({ 
  data, 
  onCardClick, 
  isModal = false, 
  loadingCardId = null,
  showAddIcon = false 
}) {
  const { t } = useTranslation();
  const [likedItems, setLikedItems] = useState({});
  const toggleLike = (id) => {
    setLikedItems((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
      <div className={`grid gap-4 mb-5 ${
        isModal 
          ? "grid-cols-3 lg:grid-cols-2 md:!grid-cols-1" 
          : "grid-cols-3 sm:!grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4"
      }`}>
        {data?.map((item) => (
          <div
            key={item.id}
            className="rounded-xl group relative flex flex-col items-start justify-center cursor-pointer"
          >
            {likedItems[item.deckId] ? (
              <IoHeart
                className="absolute top-5 z-10 right-5  md:top-3 md:right-3 text-3xl bg-white rounded-full p-1 text-red-500"
                onClick={() => toggleLike(item.deckId)}
              />
            ) : (
              <CiHeart
                className="absolute top-5 right-5   z-10 md:top-3 md:right-3 text-3xl bg-white rounded-full p-1"
                onClick={() => toggleLike(item.deckId)}
              />
            )}

            {/* Conditional rendering for modal vs normal usage */}
            {isModal ? (
              <div 
                className="w-full cursor-pointer" 
                onClick={() => onCardClick?.(item)}
              >
                <div className="relative flex justify-center items-center">
                  <img
                    src={item?.largeImageUrl || item?.smallImageUrl || "/assets/images/Zubrius.png"}
                    alt={item?.deckName}
                    loading="lazy"
                    className="w-full select-none h-[280px] aspect-3/2 group-hover:scale-95 transition-all duration-300 object-cover rounded-xl"
                  />
                  <div className="bg-black/30 absolute inset-0 backdrop-blur-sm rounded-xl group-hover:scale-95 opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                  
                  {/* Show loading spinner or add icon */}
                  {loadingCardId === item.deckId ? (
                    <ImSpinner8 
                      fontSize={50}
                      className="absolute z-10 bg-white rounded-full p-3 opacity-0 group-hover:opacity-100 transition-all duration-300 animate-spin text-blue-600"
                    />
                  ) : showAddIcon ? (
                    <IoAdd
                      fontSize={50}
                      className="absolute z-10 bg-white rounded-full p-3 opacity-0 group-hover:opacity-100 transition-all duration-300 text-blue-600"
                    />
                  ) : (
                    <IoArrowForwardSharp
                      fontSize={50}
                      className="absolute z-10 hover:-rotate-45 bg-white rounded-full p-3 opacity-0 group-hover:opacity-100 transition-all duration-300"
                    />
                  )}
                </div>
                <div className="text-sm text-lightgray flex gap-2 items-center my-2">
                  {item?.mainSubject && (
                    <>
                      <h6 className="text-center">{item?.mainSubject}</h6>
                      <GoDotFill />
                    </>
                  )}
                  <h6 className="text-center">
                    {t("gradeLabel")}: {item?.schoolGrades && item.schoolGrades.length > 0 && item.schoolGrades.some(grade => grade && grade.trim() !== "")
                      ? item.schoolGrades.filter(grade => grade && grade.trim() !== "").join(", ")
                      : "N/A"}
                  </h6>
                </div>
                <span className="line-clamp-1 group-hover:underline text-lg font-bold hover:underline">
                  {item?.deckName}
                </span>
                
                {/* Additional info for modal */}
                {isModal && (
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center gap-2">
                      <span className="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                        {item?.cards?.length || 0} cards
                      </span>
                      <span className="text-xs bg-green-100 text-green-800 px-2 py-1 rounded-full">
                        {item?.status}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <Link to={`/subject/${item?.deckId}`} className="w-full">
                <div className="relative flex justify-center items-center">
                  <img
                    src={item?.largeImageUrl}
                    alt={item?.deckName}
                    loading="lazy"
                    className="w-full select-none h-[280px] aspect-3/2 group-hover:scale-95 transition-all duration-300 object-cover rounded-xl"
                  />
                  <div className="bg-black/30 absolute inset-0 backdrop-blur-sm rounded-xl group-hover:scale-95 opacity-0 group-hover:opacity-100 transition-all duration-300"></div>
                  <IoArrowForwardSharp
                    fontSize={50}
                    className="absolute z-10 hover:-rotate-45 bg-white rounded-full p-3 opacity-0 group-hover:opacity-100 transition-all duration-300"
                  />
                </div>
                <div className="text-sm text-lightgray flex gap-2 items-center my-2 ">
                  {item?.mainSubject && (
                    <>
                      <h6 className="text-center">{item?.mainSubject}</h6>
                      {/* <GoDotFill /> */}
                    </>
                  )}
                  <GoDotFill />
                  <h6 className="text-center">
                    {t("gradeLabel")}: {item?.schoolGrades && item.schoolGrades.length > 0 && item.schoolGrades.some(grade => grade && grade.trim() !== "")
                      ? item.schoolGrades.filter(grade => grade && grade.trim() !== "").join(", ")
                      : "N/A"}
                  </h6>
                  {/* <h6 className="text-center"> Zubrus</h6> */}
                </div>
                <span className="line-clamp-1 group-hover:underline text-lg font-bold hover:underline">
                  {item?.deckName}
                </span>
              </Link>
            )}
          </div>
        ))}
      </div>
    </>
  );
}
